import api from '../../ApiConfig';
import { Apis } from '../../config';

import { Alerts } from '../index'

const getAllUsers = async () => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetAllUsers, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};


const getAllUsersWithQuery = async (role) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let queryParam = "?role=" + role;
        let result = await api.get(Apis.GetAllUsers+queryParam, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};

const getSingleUser = async (user_id) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetSingleUser+user_id, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};


const activateDeactiveUser = async (id) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.AcivateDeactivateUser+id, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};

const setUserRoles = async (data) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.SetUserRoles, data, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};

const getUserWithChild = async () => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetUsersWithChild, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};


const exportedObject = {
    getAllUsers,
    getAllUsersWithQuery,
    getSingleUser,
    activateDeactiveUser,
    setUserRoles,
    getUserWithChild
};
export default exportedObject;